



























import { defineComponent } from '@vue/composition-api';
import { InformationCircleIcon } from '@vue-hero-icons/outline';

export default defineComponent({
    name: 'VerticalFormBlock',
    props: {
        title: { type: String, required: false },
        description: {
            type: String,
            required: false,
        },
        value: {
            type: [String, Array],
            required: false,
        },
        tags: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    components: { InformationCircleIcon },
});
